/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTimecardBreakDefinition} from '../api'

 export const useQueryGetTimecardBreakDefinition = createReactQueryHook('getTimecardBreakDefinition', getTimecardBreakDefinition)
